import { SpacingProp, SpacingType } from '@payflip/types/product-builder';
import styled from 'styled-components';

type Spacing = SpacingType | SpacingProp;

const SpacingWrapper = styled.div<{ spacing?: Spacing }>`
  ${({ theme, spacing }): { [key: string]: string } => {
    const spacingSize = {
      small: theme.spacing_unit_x1,
      medium: theme.spacing_unit_x2,
      large: theme.spacing_unit_x4
    };

    if (spacing) {
      if (typeof spacing === 'string') {
        return {
          marginBottom: spacingSize[spacing],
          marginTop: spacingSize[spacing]
        };
      } else {
        const preparedStyles: { [key: string]: string } = {};

        if (spacing.bottom) {
          preparedStyles.marginBottom = spacingSize[spacing.bottom];
        }
        if (spacing.top) {
          preparedStyles.marginTop = spacingSize[spacing.top];
        }

        return preparedStyles;
      }
    }

    return {};
  }};
`;

interface PropsWithSpacing {
  spacing?: Spacing;
  [key: string]: unknown;
}

export function withSpacingProps<T extends PropsWithSpacing>(
  Component: React.ComponentType<Omit<T, 'spacing'>>
): React.FC<T> {
  return (props) => {
    const { spacing, ...otherProps } = props;

    return (
      <SpacingWrapper spacing={spacing}>
        <Component {...otherProps} />
      </SpacingWrapper>
    );
  };
}
